import { FC, ReactElement } from 'react'
import { WhiteTooltip } from '../../Tooltip/WhiteTooltip'
import Styles from './DateChangedCallout.module.scss'

export const DateChangedCallout: FC<React.PropsWithChildren<{ children: ReactElement }>> = ({ children }) => (
  <WhiteTooltip
    label={
      <div>
        <strong className={Styles.heading}>Due date was updated</strong>
        <p className={Styles.text}>Reviews have to end before the next one is scheduled to start.</p>
      </div>
    }
    callOut
    placement="bottom"
  >
    {children}
  </WhiteTooltip>
)
